import { reduceErrors } from '../errors';

import { INVALID } from '../../constants/variations';
import { ERROR } from '../../constants/product';

export function setInvalid(variations) {
  return variations.set(INVALID, reduceErrors(variations.get(ERROR)));
}
